import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import logoVector from "../../assets/images/vector-logo.svg";
import { useNavigate } from "react-router-dom"; // Import useNavigate hook

const LogoutButton = () => {
  const [messageVisible, setMessageVisible] = useState(false);
  const navigate = useNavigate(); // Initialize useNavigate for redirecting
  const [user, setUser] = useState(null);

  // Check if user exists in localStorage
  // useEffect(() => {
  //   const storedUser = JSON.parse(localStorage.getItem("user"));
  //   if (!storedUser) {
  //     navigate("/admin-login"); // Redirect if user is not found
  //   } else {
  //     setUser(storedUser);
  //   }
  // }, [navigate]);

  // Handle button click
  const handleLogout = () => {
    // Remove JWT token and user data from localStorage
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("user");
    localStorage.removeItem("admin");
    // localStorage.clear();

    console.log("User logged out");

    setMessageVisible(true); // Show logout message

    // Redirect to the login page after showing the message
    setMessageVisible(false); // Hide the message after 3 seconds
    navigate("/login"); // Redirect to the login page
    // setTimeout(() => {
    //   setMessageVisible(false); // Hide the message after 3 seconds
    //   navigate("/login"); // Redirect to the login page
    // }, 3000);
  };

  const logoutStyle = {
    btnLogOut: {
      background: "#065F9C",
      borderRadius: "10px",
      fontSize: "16px",
      width: "auto",
      padding: "15px 30px",
      lineHeight: "1.2",
    },
  };

  return (
    <div style={{ textAlign: "center", marginTop: "20px" }}>
      <img
        src={logoVector}
        alt="Flyover"
        style={{ height: 45, marginRight: 25 }}
      />
      <p style={{ fontSize: "16px", color: "#333", fontWeight: "500" }}>
        Click the button below to log out of your account.
      </p>

      <Button
        style={logoutStyle.btnLogOut}
        variant="contained"
        color="primary"
        onClick={handleLogout}
      >
        Log Out
      </Button>

      {messageVisible && (
        <Typography
          variant="body1"
          color="success"
          style={{ marginTop: "10px" }}
        >
          You have been logged out successfully!
        </Typography>
      )}
    </div>
  );
};

export default LogoutButton;
